module.exports = __webpack_public_path__ + "static/media/main_visual_agriculture_telehandler_mlt_730_115_v_cp_manitou.dea354c1.png";